import { Injectable, ElementRef, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NgpService {

  LightboxElement: ElementRef;
}
